import axios from "axios";
import { url } from "./url";

export async function loadProfile(token) {
  let response = (await axios.get(`${url}/api/auth/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })) || { data: {} };
  if (response.data.success) {
    return response.data.data;
  }
}

export async function loadUserProfile(userId, token) {
  let response = (await axios.get(`${url}/api/auth/profile/${userId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })) || { data: {} };
  if (response.data.success) {
    return response.data.data;
  }
}

export async function fetchChats(token) {
  let response = (await axios.get(`${url}/api/auth/me/messages/chats`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })) || { data: {} };
  if (response.data.success) {
    return response.data.data;
  }
}

export async function fetchChatsWithMessages(token) {
  let response = (await axios.get(
    `${url}/api/auth/me/messages/chatsWithMessages`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )) || { data: {} };
  if (response.data.success) {
    return response.data.data;
  }
}

export async function getMessages(user, token) {
  let response;
  response = await axios
    .get(`${url}/api/auth/${user}/messages`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .catch((err) => (response = err.response));
  return response ? response.data.data || [] : [];
}

export async function sendMessage(data, user, token) {
  let response;
  response = await axios
    .post(`${url}/api/auth/${user}/messages`, data, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .catch((err) => (response = err.response));
  return response;
}

export async function readMessages(user, token) {
  let response;
  response = await axios
    .put(
      `${url}/api/auth/${user}/messages`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .catch((err) => (response = err.response));
  return response;
}

export async function loadPost(token, id) {
  let response = (await axios.get(`${url}/api/posts/getposts/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })) || { data: {} };
  if (response.data.success) {
    return response.data.data;
  }
}
